import {PropsWithChildren, createContext} from "react";

import {ServiceVariableGroupByCredential, ServiceVariableNoServiceInput} from "@/lib/types/serviceVariables.ts";

export interface NewCheckVaultItemsContextInterface {
  checkId?: number;
  setCheckId: (checkId: number | undefined) => void;
  vaultItems: ServiceVariableGroupByCredential[];
  setVaultItems: (vaultItems: ServiceVariableGroupByCredential[]) => void;
  deleteVaultItem: (id: string) => void;
  addVaultItem: (item: ServiceVariableGroupByCredential) => void;
  updateVaultServiceVariableName: (
    credentialId: string,
    serviceVariableProperty: string,
    serviceVariableName: string
  ) => boolean;
  getServiceVariableInputFromVaultItems: () => ServiceVariableNoServiceInput[];
}

const DEFAULT_VALUE: NewCheckVaultItemsContextInterface = {
  checkId: undefined,
  setCheckId: () => {},
  vaultItems: [],
  setVaultItems: () => {},
  deleteVaultItem: () => {},
  addVaultItem: () => {},
  updateVaultServiceVariableName: () => false,
  getServiceVariableInputFromVaultItems: () => [],
};

export const NewCheckVaultItemsContext = createContext<NewCheckVaultItemsContextInterface>(DEFAULT_VALUE);

interface NewCheckVaultItemsProviderProps extends PropsWithChildren<NewCheckVaultItemsContextInterface> {}

export const NewCheckVaultItemsProvider = ({children, ...rest}: NewCheckVaultItemsProviderProps) => {
  return <NewCheckVaultItemsContext.Provider value={{...rest}}>{children}</NewCheckVaultItemsContext.Provider>;
};
